import { TBlogArticleWidget } from '../../blog/blog.types';
import { BlogArticleJoinNowWidget } from '../BlogArticleJoinNowWidget';

type Props = {
  widget: TBlogArticleWidget;
  mobile?: boolean;
};

export const BlogArticleWidget: React.FC<Props> = ({
  widget,
  mobile = false,
}) => {
  switch (widget.__typename) {
    case 'blogWidgetJoinNow': {
      return <BlogArticleJoinNowWidget widget={widget} mobile={mobile} />;
    }
    default: {
      return null;
    }
  }
};
